export enum AppVersion {
    FULL = "full",
    TRIAL = "trial",
}
